import { getAllCertificates, updateCertificate } from './db.js';
import { formatDate } from './utils.js';

const NOTIFICATION_THRESHOLDS = [365, 30, 7, 0];

export function getNotifPreference() {
    return localStorage.getItem('notificationsEnabled') === 'true';
}

export function setNotifPreference(enabled) {
    localStorage.setItem('notificationsEnabled', enabled ? 'true' : 'false');
}

export async function requestNotificationPermission() {
    try {
        if ('Notification' in window && Notification.permission === 'default') {
            await Notification.requestPermission();
        }
    } catch (err) {
        console.warn('Notification permission request failed:', err);
    }
}

async function sendNotification(title, body) {
    if (!('Notification' in window) || Notification.permission !== 'granted') return;
    if (!getNotifPreference()) return;

    try {
        if ('serviceWorker' in navigator) {
            const registration = await navigator.serviceWorker.ready;
            await registration.showNotification(title, {
                body,
                icon: 'icons/icon-192.png',
                badge: 'icons/icon-192.png'
            });
        }
    } catch (err) {
        console.warn('Notification failed:', err);
    }
}

export async function checkExpiringCertificates() {
    const certificates = await getAllCertificates();
    const today = new Date();

    for (const cert of certificates) {
        const expiry = new Date(cert.expiryDate);
        const daysUntilExpiry = Math.ceil((expiry - today) / (1000 * 60 * 60 * 24));
        const notifiedThresholds = cert.notifiedThresholds || [];

        for (const threshold of NOTIFICATION_THRESHOLDS) {
            if (notifiedThresholds.includes(threshold)) continue;

            let shouldNotify = false, title = '', body = '';

            if (threshold === 365 && daysUntilExpiry <= 365 && daysUntilExpiry > 30) {
                shouldNotify = true;
                title = '📅 Certificate Expiring Within 1 Year';
                body = `${cert.name} expires on ${formatDate(cert.expiryDate)} (${daysUntilExpiry} days left)`;
            } else if (threshold === 30 && daysUntilExpiry <= 30 && daysUntilExpiry > 7) {
                shouldNotify = true;
                title = '⚠️ Certificate Expiring Soon';
                body = `${cert.name} expires in ${daysUntilExpiry} days on ${formatDate(cert.expiryDate)}`;
            } else if (threshold === 7 && daysUntilExpiry <= 7 && daysUntilExpiry > 0) {
                shouldNotify = true;
                title = '🚨 Certificate Expires This Week!';
                body = `${cert.name} expires in ${daysUntilExpiry} days!`;
            } else if (threshold === 0 && daysUntilExpiry <= 0) {
                shouldNotify = true;
                title = '❌ Certificate Expired';
                body = `${cert.name} has expired${daysUntilExpiry === 0 ? ' today' : ` ${Math.abs(daysUntilExpiry)} days ago`}`;
            }

            if (shouldNotify) {
                await sendNotification(title, body);
                notifiedThresholds.push(threshold);
                await updateCertificate(cert.id, { notifiedThresholds });
            }
        }
    }
}
